import type { FC } from 'react';
import SearchBoxDefault from '@/Module/DefaultLayout/Component/Search/SearchBoxDefault';
import { useSearch } from '@/Module/DefaultLayout/Hook';
const HomePageSearchWrapper: FC = () => {
  const {
    onToggle
  } = useSearch();
  return <div className=" bg-center bg-no-repeat pb-6 sm:py-12  " data-sentry-component="HomePageSearchWrapper" data-sentry-source-file="HomePageSearchWrapper.tsx">
      <div className="mx-auto flex w-full items-center justify-center">
        <SearchBoxDefault onToggle={onToggle} data-sentry-element="SearchBoxDefault" data-sentry-source-file="HomePageSearchWrapper.tsx" />
      </div>
    </div>;
};
export default HomePageSearchWrapper;